module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    class: ['form-control-static', _vm.inputClass],
    attrs: {
      "id": _vm._id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.staticValue)
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1e5702a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/form-input-static.vue
// module id = 257
// module chunks = 0